export const landingTexts = {
  banner: {
    title: "Agente Ualabi",
    subtitle: "Tu nuevo asistente para la consulta y revisión de documentación técnica"
  },
  storyPoints: {
    problem: {
      title: "El Dilema de la Documentación Técnica",
      content: {
        paragraph: "Día a día, industrias se enfrentan a <strong>grandes desafíos administrativos</strong> con documentos mal usados en tiempo y forma, provocando errores en distintas unidades sin especialidad en componentes técnicos.",
        listItems: [
          "Procesos de capacitación costosos y no escalables",
          "Interpretaciones de documentos sin trazabilidad",
          "Dificultad para dar seguimiento al origen de los problemas"
        ]
      }
    },
    solution: {
      title: "Conoce al Agente Ualabi",
      content: {
        paragraph: "Una plataforma de Inteligencia Artificial Conversacional especializada en tú documentación técnica.",
        listItems: [
          "Solo responder desde fuentes oficiales",
          "Accesible a través de distintos medios",
          "Fomenta un aprendizaje progresivo y una validación compartida"
        ]
      }
    }
  },
  faq: {
    title: "Preguntas Frecuentes",
    items: [
      {
        question: "¿Qué puedes hacer con Ualabi?",
        answer: [
          "Con Ualabi puedes encontrar documentación técnica de múltiples rubros, siempre actualizada y validada por fuentes oficiales y profesionales de cada área. Algunas de las cosas que Ualabi puede hacer incluyen:",
          "",
          "📄 Ubicar y explicar secciones específicas de normativas, manuales técnicos o guías sectoriales (construcción, energía, salud, transporte, telecomunicaciones, etc.).",
          "",
          "🔍 Aportar contexto y requisitos técnicos vigentes para proyectos, procesos o certificaciones en distintas industrias.",
          "",
          "📚 Comparar regulaciones o estándares entre documentos y organismos cuando sea pertinente.",
          "",
          "🧾 Citar textualmente la fuente y mostrar de qué documento proviene la información (por ejemplo, \"según la NCh XXXX, sección Y\").",
          "",
          "🧠 Facilitar la interpretación de lenguaje técnico o legal, convirtiéndolo en instrucciones claras y accionables.",
          "",
          "✅ Apoyar revisiones y auditorías normativas, ayudando a profesionales a comprobar el cumplimiento de requisitos oficiales.",
          "",
          "",
          "Y lo mejor: Ualabi solo responde con información respaldada por su base de datos de documentos oficiales y la validación de expertos, garantizando precisión y trazabilidad en cada respuesta."
        ]
      },
      {
        question: "¿Cómo puedo empezar?",
        answer: [
          "Para empezar a usar Ualabi, crea una cuenta y simplemente envía un mensaje a nuestro chat web o realiza búsquedas semánticas o textuales sobre nuestras colecciones de documentos.",
          "Cada conversación tomara como referencia el contexto seleccionado para responder, por ejemplo, si seleccionas la construcción chilena, la conversación se basara en documentos de construcción chilena.",
          "",
          "Es importante considerar que Ualabi está diseñado para responder exclusivamente sobre el contexto seleccionado, así que asegúrate de formular tus preguntas de manera clara."
        ]
      },
      {
        question: "¿Qué canales de comunicación están disponibles?",
        answer: [
          "Actualmente nos encontramos en una fase de prueba y solo estamos disponibles a través de nuestro chat web.",
          "",
          "En el futuro, planeamos expandirnos a nuevos canales, como servidores MCP, WhatsApp y diferentes tipos de integraciones con agentes de otras organizaciones."
        ]
      },
      {
        question: "¿Cómo funciona el agente Ualabi?",
        answer: [
          "Nuestro foco esta en desarrollar una base de datos de documentos normativos y reglamentos aplicados a diferentes ámbitos. Ualabi utiliza modelos de lenguaje en conjunto a técnicas avanzadas de procesamiento de lenguaje natural para analizar y comprender estos documentos, lo que le permite responder preguntas y proporcionar información relevante de manera precisa y contextualizada.",
          "",
          "Ualabi no tiene acceso a internet, por lo que no puede buscar información fuera de su base de datos. Esto asegura que las respuestas sean precisas y basadas en la información disponible.",
          "",
          "Además, Ualabi está diseñado para aprender y mejorar con el tiempo, lo que significa que su capacidad para responder preguntas y proporcionar información relevante seguirá creciendo con su uso y en la medida que se agreguen más documentos y se realicen mejoras en el modelo."
        ]
      },
      {
        question: "¿Necesitas saber algo más?",
        answer: [
          "Puedes consultar todo lo que necesites saber a través de nuestro correo electrónico a contacto@ualabi.co"
        ]
      }
    ]
  },
  roadmap: {
    title: "Development Roadmap",
    items: [
      {
        title: "Desarrollo de nuestra API",
        description: "Lanzamiento de la versión beta de la API Agente Ualabi con funcionalidades básicas de consultoría.",
        date: "Q1 2025",
        completed: true
      },
      {
        title: "Desarrollo de nuestro Frontend",
        description: "Desarrollo de un frontend web e integración con nuestros servidores.",
        date: "Q2 2025",
        completed: false
      },
      {
        title: "Desarrollo proceso de ingestion de documentos",
        description: "Implementación de un sistema de ingestión de documentos para mejorar la calidad de las respuestas.",
        date: "Q3 2025",
        completed: false
      },
      {
        title: "Deployment de la API y plataforma en producción",
        description: "Lanzamiento de la API y la plataforma en producción, con soporte completo para consultas y respuestas.",
        date: "Q4 2025",
        completed: false
      }
    ]
  }
}; 